import React, { useEffect, useState, useCallback } from "react";
import "../../_css/ReviewAns.css";
import QASheet from "./QASheet";
import AIEval from "./AIEval";
import AnswerPDF from "./AnswerPDF";
import Feedback from "./Feedback";
import { useDispatch } from "react-redux";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getAllPdfs, reannotatePdf } from "../../requests";
import { deleteAuthToken } from "../../utils/helper";
import { notifyError, notifySuccess } from "../helper/Toaster";
import SearchableDropdown from "../common/SearchableDropdown";

const ReviewAns = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const startInComparison = searchParams.get("view") === "comparison";
  const [view, setView] = useState(startInComparison ? "pdf" : "default");
  const [showMemo, setShowMemo] = useState(startInComparison);
  const [comparisonFullscreen, setComparisonFullscreen] = useState(false);
  const [showfd, setShowfd] = useState(false);
  const [question, setquestion] = useState("");
  const [Student, setStudent] = useState("John");
  const [aiEvalId, setAiEvalId] = useState(0)
  const [refresh, setRefresh] = useState(false)
  const[questions, setQuestions] = useState([{id:0, question:"All Questions"}])
  const [nextId, setNextId] = useState(null);
  const [previousId, setPreviousId] = useState(null);


  const [pdfs, setAllPdfs] = useState("");

  const getAllIds = () => {
    try {
      const stored = JSON.parse(localStorage.getItem("allIds"));
      if (!Array.isArray(stored)) return [];
      return stored.map((studentId) => String(studentId));
    } catch {
      return [];
    }
  };

  const updateAdjacentIds = useCallback(() => {
    const allIds = getAllIds();
    const currentIndex = allIds.indexOf(String(id));

    if (currentIndex === -1) {
      setNextId(null);
      setPreviousId(null);
      return;
    }

    setNextId(allIds[currentIndex + 1] || null);
    setPreviousId(currentIndex > 0 ? allIds[currentIndex - 1] : null);
  }, [id]);

  useEffect(() => {
    updateAdjacentIds();
  }, [updateAdjacentIds]);

  const goToStudent = (studentId) => {
    if (!studentId) return;
    setquestion("");
    setAiEvalId(0);
    setQuestions([{ id: 0, question: "All Questions" }]);
    navigate(`/student-list/review-answers/${studentId}?view=comparison`);
  };


  const handleBtn = async () => {



    if (view == "pdf") {
      setShowMemo(!showMemo);
      return;
    }

    setShowfd(!showfd);

    
  };

  const handle_drp = (e) => {
    setquestion(e);

    if (e == "All Questions") {
      setView("default");
      setAiEvalId(0)
      return;
    }       
    
    let id = questions.find((el)=>el.question == e)?.id

   
    
    
    if(id){
      setAiEvalId(id)
      setView("eval")

    }
  

    
    
  };

  const handleReannotate = async () => {
    if (!id) return;

    dispatch(startLoader());
    try {
      const res = await reannotatePdf(id);
      if (res.status < 400) {
        notifySuccess(
          res?.data?.message || "Answer sheet reannotated successfully"
        );
        setRefresh((r) => !r);
      }
    } catch (error) {
      if (error?.response?.status === 403) {
        deleteAuthToken();
        notifyError(
          error?.response?.data?.error ||
            "Your session has expired. Please log in again."
        );
        navigate("/login");
        return;
      }
      const apiMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Failed to reannotate answer sheet";
      notifyError(apiMessage);
    } finally {
      dispatch(stopLoader());
    }
  };

  const get_pdf = async () => {
    dispatch(startLoader());

    if(!id){
      return;
    }

    try {
      const res = await getAllPdfs({ id: Number(id) });
      // console.log(res.data.data);
      console.log("PDFS", res.data.data);

      setAllPdfs(res.data.data);

   
     

      setStudent(res.data.data.student_name);
    } catch (error) {
      console.log(error);
      if (error?.response?.status == 403) {
        deleteAuthToken();

        notifyError(
          error?.response?.data?.error || "Your session has expired. Please log in again."
        );

        navigate("/login");

        return;
      }
      notifyError(error.response?.data?.error || "Error fetching files");
    } finally {
      dispatch(stopLoader());
    }
  };


  useEffect(() => { 
    get_pdf();
  }, [id,refresh]);

  const exitComparisonFullscreen = useCallback(() => {
    setComparisonFullscreen(false);
  }, []);

  useEffect(() => {
    if (!showMemo) {
      setComparisonFullscreen(false);
    }
  }, [showMemo]);

  useEffect(() => {
    if (!comparisonFullscreen) return undefined;

    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        exitComparisonFullscreen();
      }
    };

    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [comparisonFullscreen, exitComparisonFullscreen]);

  return (
    <div className="review-main">
      <div className="review-head">
        <div className="review-head-left">
          <div
            onClick={() =>
              view != "default" &&  (setView("default"), setquestion('All Questions')) 
            }
            className="review-head-text"
            style={{
              color: view != "pdf" ? "#FFFFFF" : "#030712",
              backgroundColor: view != "pdf" && "#01A7DE",
            }}
          >
            AI Marking
          </div>
          <div
            onClick={() => (view != "pdf" && setView("pdf"))}
            className="review-head-text"
            style={{
              color: view == "pdf" ? "#FFFFFF" : "#030712",
              backgroundColor: view == "pdf" ? "#01A7DE" : "",
            }}
          >
           Pupils Answer Sheet
          </div>
        </div>
       
        <button onClick={handleBtn} className="review-head-btn">
          {view == "pdf"
            ? showMemo
              ? "Hide comparison"
              : "Show comparison"
            : "Generate Feedback"}
        </button>
      </div>

      <div className="review-student">
        {/* VIEW IS EMPTY */}
        {view == "default" && (
          <>
            <div className="review-student-head">
              <div className="review-student-text">
                {Student} &nbsp;&nbsp;
                {/* <span style={{ fontWeight: "200", fontSize: "16px" }}>
                  &gt;
                </span> */}
              </div>
              <div className="review-student-text" style={{fontSize:"18px"}}>Total Marks : {Number(pdfs?.marks_obt)}/{Number(pdfs?.marks_total)}</div>
              <div style={{ width: "25%" }}>
                <SearchableDropdown
                  options={questions.map((e)=>e.question)}
                  selected={question}
                  setSelected={handle_drp}
                  allowManualEntry={false}
                  color="#E5E7EB"
                />
              </div>
            </div>

            <div style={{ width: "99%" }}>
              <QASheet fn={(e,id) => (setView("eval"), setquestion(e),setAiEvalId(id))}  refresh = {refresh}  setQuestions = {setQuestions} aiEvalId = {aiEvalId} id = {id} />
              <div className="review-reannotate-wrap">
                <button
                  type="button"
                  className="review-head-btn"
                  onClick={handleReannotate}
                >
                  Reannotate answer sheet
                </button>
              </div>
            </div>
          </>
        )}

        {/* VIEW IS DEFAULT */}
        {view == "eval" && (
          <>
            <div className="review-student-head">
              <div className="review-student-text">
                {Student}
                {/* <span style={{ fontWeight: "200", fontSize: "16px" }}>
                  &gt;
                </span> */}
              </div>
              <div className="review-student-text" style={{fontSize:"18px"}}>Total Marks : {Number(pdfs?.marks_obt)}/{Number(pdfs?.marks_total)}</div>
              <div style={{ width: "25%" }}>
                <SearchableDropdown
                  options={questions.map((e)=>e.question)}
                  selected={question}
                  setSelected={handle_drp}
                  allowManualEntry={false}
                  color="#E5E7EB"
                />
              </div>
            </div>

            <div style={{ width: "99%" }}>
              <div style={{ display: "flex" }}>
                <div style={{ width: "70%" }}>
                  <QASheet fn={(e,id) => (setView("eval") , setquestion(e), setAiEvalId(id)) } refresh = {refresh} setQuestions = {setQuestions} aiEvalId = {aiEvalId} id = {id}/>
                </div>
                <AIEval id = {aiEvalId} fn={() => (setView("default"), setquestion("All Questions"),setAiEvalId(0))  }  setRefresh = {setRefresh}  refresh = {refresh} />
              </div>
              <div className="review-reannotate-wrap">
                <button
                  type="button"
                  className="review-head-btn"
                  onClick={handleReannotate}
                >
                  Reannotate answer sheet
                </button>
              </div>
            </div>
          </>
        )}

        {/* VIEW IS PDF */}
        {view == "pdf" && !showMemo && (
          <>
            <div className="review-student-head">
              <div className="review-student-text">Answer Sheet</div>
              <div className="review-ans-icon">
                {/* <img src="/menu-icon.svg" width="18px" height="18px" />{" "} */}
                {/* <img src="/menu-icon.svg" width="18px" height="18px" />{" "} */}
              </div>
            </div>

            <div style={{ width: "99%" }}>
              <AnswerPDF pdf={pdfs?.answersheeturlmarkedwf || pdfs?.answersheeturl} />

            </div>
          </>
        )}

        {/* Answer Memo */}
        {view == "pdf" && showMemo && (
          <div
            className={
              comparisonFullscreen
                ? "review-comparison review-comparison--fullscreen"
                : "review-comparison"
            }
            role={comparisonFullscreen ? "dialog" : undefined}
            aria-modal={comparisonFullscreen ? "true" : undefined}
            aria-label={
              comparisonFullscreen ? "Side-by-side answer comparison" : undefined
            }
          >
            <div className="review-comparison-nav">
              <button
                type="button"
                className="review-comparison-nav-btn"
                onClick={() => goToStudent(previousId)}
                disabled={!previousId}
              >
                Previous
              </button>
              <div className="review-comparison-nav-title">{Student}</div>
              <button
                type="button"
                className="review-comparison-nav-btn"
                onClick={() => goToStudent(nextId)}
                disabled={!nextId}
              >
                Next
              </button>
            </div>
            <div className="review-comparison-panels">
              <div className="review-comparison-panel">
                <div className="review-student-head">
                  <div className="review-student-text">Answer Sheet</div>
                </div>
                <div className="review-comparison-panel-body">
                  <QASheet
                    inlineEditMarks
                    setRefresh={setRefresh}
                    refresh={refresh}
                    setQuestions={setQuestions}
                    aiEvalId={aiEvalId}
                    id={id}
                    fn={(e, qId) => (
                      setView("eval"),
                      setquestion(e),
                      setAiEvalId(qId)
                    )}
                  />
                  <div className="review-reannotate-wrap">
                    <button
                      type="button"
                      className="review-head-btn"
                      onClick={handleReannotate}
                    >
                      Reannotate answer sheet
                    </button>
                  </div>
                </div>
              </div>

              <div className="review-comparison-panel review-comparison-panel--pdf">
                <div className="review-student-head">
                  <div className="review-student-text">
                    AI Marked Answer Sheet
                  </div>
                  <div className="review-comparison-toolbar-actions">
                    {comparisonFullscreen && (
                      <span className="review-comparison-hint">
                        Press Esc to exit
                      </span>
                    )}
                    <button
                      type="button"
                      className="review-comparison-fs-btn"
                      onClick={() =>
                        comparisonFullscreen
                          ? exitComparisonFullscreen()
                          : setComparisonFullscreen(true)
                      }
                      aria-pressed={comparisonFullscreen}
                      aria-label={
                        comparisonFullscreen
                          ? "Exit fullscreen comparison"
                          : "View comparison in fullscreen"
                      }
                      title={
                        comparisonFullscreen
                          ? "Exit fullscreen (Esc)"
                          : "Fullscreen"
                      }
                    >
                      {comparisonFullscreen ? (
                        <>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            aria-hidden="true"
                          >
                            <path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3" />
                          </svg>
                          Exit fullscreen
                        </>
                      ) : (
                        <>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            aria-hidden="true"
                          >
                            <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" />
                          </svg>
                          Fullscreen
                        </>
                      )}
                    </button>
                  </div>
                </div>
                <div className="review-comparison-panel-body review-comparison-panel-body--pdf">
                  <AnswerPDF
                    pdf={
                      pdfs?.answersheeturlmarkedwf || pdfs?.answersheeturl
                    }
                    fillHeight={comparisonFullscreen}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Answer Memo
        {view == "eval" && showMemo && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "99%",
              height: "100%",
            }}
          >
            <div style={{ width: "49%" }}>
              <>
                <div className="review-student-head">
                  <div className="review-student-text">Answer Sheet</div>
                  <div className="review-ans-icon">
                    <img src="/menu-icon.svg" width="18px" height="18px" />{" "}
                    <img src="/menu-icon.svg" width="18px" height="18px" />{" "}
                  </div>
                </div>

                <div style={{ width: "99%", display: "flex" }}>
              <div style={{ width: "70%" }}>
                <QASheet fn={(e,id) => (setView("eval") , setquestion(e), setAiEvalId(id)) } refresh = {refresh} setQuestions = {setQuestions} aiEvalId = {aiEvalId} id = {id}/>
              </div>
              <AIEval id = {aiEvalId} fn={() => (setView("default"), setquestion("All Questions"),setAiEvalId(0))  }  setRefresh = {setRefresh}  refresh = {refresh} />
            </div>
              </>
            </div>
            <div style={{ width: "49%" }}>
              <>
                <div className="review-student-head">
                  <div className="review-student-text">Answer Memo</div>
                  <div className="review-ans-icon">
                    <img src="/menu-icon.svg" width="18px" height="18px" />{" "}
                    <img src="/menu-icon.svg" width="18px" height="18px" />{" "}
                  </div>
                </div>

                <div style={{ width: "99%" }}>
                  <AnswerPDF pdf={pdfs?.answerkeyurl} />
                </div>
              </>
            </div>
          </div>
        )} */}

        {/* Feedback */}
        {showfd && <Feedback fn={() => setShowfd(false)}  id={id} disabled={false}/> }
      </div>
    </div>
  );
};

export default ReviewAns;
